/* eslint-disable jsx-a11y/anchor-is-valid */
// This component contains the contact form and video along with the
// images associated to the Figma design for this section.

import { Container, Col, Row, Button, Image, Fade } from 'react-bootstrap';
import '../Header/header.css'
import React, { useState } from 'react';
import LeftD from '../Images/Left-dots.png'
import RippleGroup from '../Images/RippleGroup.png'
import MagnifyingGroup from '../Images/MagnifyingGroup2.png'
import MagnifyingMobile from '../Images/MagnifyingMobile2.png'
import RightD from '../Images/Right-dots.png'
import Contact from '../Contact/Contact';
import ModalVideo from 'react-modal-video'
import FadeIn from 'react-fade-in';
import parser from "html-react-parser";


export default function Header({sunwestLink1}) {
  const [show, setShow] = useState(false);
  const [isOpen, setOpen] = useState(false)
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
    {/* Will keep the contact form modal hidden in case it is requested to
    be activated in the future. */}
      {/* <Modal show={show} onHide={handleClose}>
        <Modal.Body>
          <Contact />
        </Modal.Body>
      </Modal> */}

      <Container className='TopContainer mx-auto' fluid>
      
        <Row className='g-0 align-items-center justify-content-lg-around justify-content-md-center'>
          <Image className='LeftD' src={LeftD} fluid />
          <Image className='RippleGroup' src={RippleGroup} fluid />
          <Col md={show ? 10 : { span: 5, offset: 1 }} lg={{ span: 6, offset: 1 }} xl={{ span: 4, offset: 1 }}>
            {/* This is the logic to show the contact from using the fade in effect
            instead of the original popup modal effect. */}
            {!show ?
              <FadeIn>
                <h1 className='Intro'><span className='SunWest'>{parser(sunwestLink1)} Introduces</span></h1>
                <h1><strong className='Waiver'>Early Property</strong></h1>
                <h1><strong className='Inspection'> Inspection Waiver</strong></h1>
                <Button className="Callback" onClick={handleShow}>
                  Request A Call Back
                </Button>
              </FadeIn> :
              <Fade>
                <Contact />
              </Fade>
            }
          </Col>
          <Col md={6} lg={4} xl={5}>
            <div id='ImageWrapper'>
            <a href='#' id='PlayDesktop2' onClick={() => setOpen(true)}>
              <Image className='MagnifyingGroup' src={MagnifyingGroup} fluid />
             
                {/* <Image className='Play' src={Play} fluid /> */}
              </a>
              {/* This is the logic to show the Maginifying Glass mobile image when the 
              "Request A Call Back" button is clicked on. The original modal was not used
              because it was requested the effect be chgned from 'popup' to fade in. */}
              {!show ?
              <>
                <a href='#' id='PlayMobile' onClick={() => setOpen(true)}>
                <Image className='MagnifyingMobile' src={MagnifyingMobile} fluid />
              
                {/* <Image className='Play' src={Play} fluid /> */}
              </a>
              </>
                :
                <Button className="ReturnToVideo" onClick={handleClose}>
                  Return to Video
                </Button>
              }
            </div>
          </Col>
          <Image className='RightD' src={RightD} />
        </Row>
      </Container>
      <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="IwCEbhp2ON8" onClose={() => setOpen(false)} />
    </>
  )
}
